import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 mx-auto text-slate-400" />
      <h1 className="font-display text-2xl font-bold text-[#0F2137] mt-4">Paiement annulé</h1>
      <p className="text-slate-600 mt-2">
        Aucun montant n'a été prélevé. Vous pouvez retenter à tout moment.
      </p>
      <div className="mt-6 flex gap-3 justify-center">
        <Link to="/tarifs">
          <Button className="bg-[#F59E0B] hover:bg-[#D97706] text-[#0F2137] font-semibold">
            Retour aux offres
          </Button>
        </Link>
        <Link to="/">
          <Button variant="outline">Accueil</Button>
        </Link>
      </div>
    </div>
  );
}
